import React from "react";

import { format } from "date-fns";

export const PREPAID_COLUMNS = (totalHours) => [
  {
    Header: "Date",
    accessor: "invoice_date",
    id: "invoice_date",
    maxWidth: 350,
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yy") : "--"),
    Footer: "Total Purchased/Credit"
  },
  {
    Header: "Hours Purchased",
    accessor: "hours_purchased",
    id: "hours_purchased",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    Footer: totalHours
  },
  {
    Header: "Invoice Number",
    accessor: "invoice_number",
    id: "invoice_number"
  }
];

export const PROJECT_COLUMNS = (totalHours, purchase, balance) => [
  {
    Header: "Project Name",
    accessor: "name",
    id: "name",
    maxWidth: 350,
    Footer: (
      <div>
        <div>Total Purchased/Credit</div>
        <div>Total Used</div>
        {!!balance && <div>Balance Available</div>}
      </div>
    )
  },
  {
    Header: "Hours Used",
    accessor: "billableHours",
    id: "billableHours",
    maxWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    Footer: (
      <div>
        <div>{purchase}</div>
        <div>{totalHours}</div>
        {!!balance && <div>{balance}</div>}
      </div>
    )
  },
  {
    Header: "Note",
    accessor: "project.notes",
    id: "notes",
    Cell: ({ value }) =>
      Array.isArray(value) && value.length
        ? value[0]?.note.replace(/<[^>]*>?/gm, "")
        : ""
  }
];

export const CALL_COLUMNS = (startDate, endDate, totalHours) => [
  {
    Header: "Date",
    accessor: "arrival_date",
    id: "arrival_date",
    maxWidth: 100,
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yy") : "--")
  },
  {
    Header: "Project Name",
    accessor: "project",
    id: "project.name",
    maxWidth: 250,
    Footer:
      startDate && endDate
        ? `Total ${format(startDate, "MM/dd/yyyy")} to ${format(
            endDate,
            "MM/dd/yyyy"
          )}`
        : ""
  },
  {
    Header: "Hours Used",
    accessor: "billable_hrs",
    id: "billable_hrs",
    maxWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    Footer: totalHours
  },
  {
    Header: "Employee",
    accessor: "assigned_to",
    id: "assigned_to",
    maxWidth: 200
  },
  {
    Header: "Description",
    accessor: "billing_description",
    id: "billing_description",
    Cell: ({ value, row }) =>
      `${value ?? ""} ${
        row.original?.support_ticket_id || row._original?.support_ticket_id
          ? `- Ticket #${
              row.original?.support_ticket_id ||
              row._original?.support_ticket_id ||
              ""
            }`
          : ""
      }`
  }
];

export const CALL_COLUMNS_WITH_NOTE = (startDate, endDate, totalHours) => [
  {
    Header: "Date",
    accessor: "arrival_date",
    id: "arrival_date",
    maxWidth: 100,
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yy") : "--")
  },
  {
    Header: "Project Name",
    accessor: "project",
    id: "project.name",
    maxWidth: 250,
    Footer:
      startDate && endDate
        ? `Total ${format(startDate, "MM/dd/yyyy")} to ${format(
            endDate,
            "MM/dd/yyyy"
          )}`
        : "'"
  },
  {
    Header: "Hours Used",
    accessor: "billable_hrs",
    id: "billable_hrs",
    maxWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    Footer: totalHours
  },
  {
    Header: "Employee",
    accessor: "assigned_to",
    id: "assigned_to",
    maxWidth: 200
  },
  {
    Header: "Description",
    accessor: "billing_description",
    id: "billing_description",
    Cell: ({ value, row }) =>
      `${value ?? ""} ${
        row.original?.support_ticket_id || row._original?.support_ticket_id
          ? `- Ticket #${
              row.original?.support_ticket_id ||
              row._original?.support_ticket_id ||
              ""
            }`
          : ""
      }`
  },
  {
    Header: "Internal Note",
    accessor: "internal_notes",
    id: "internal_notes"
  }
];
